module.exports = __webpack_public_path__ + "static/media/news-betz.043da4eb.jpg";